// extracted by mini-css-extract-plugin
export var target = "style-module--target--63362";
export var target__item = "style-module--target__item--1f550";
export var target__itemText = "style-module--target__item--text--4ff07";
export var target__list = "style-module--target__list--7f688";
export var target__title = "style-module--target__title--668a1";